{
  "name": "monimilk",
  "version": "1.6.46",
  "description": "monimilk",
  "private": true,
  "engines": {
    "node": "24",
    "npm": "11"
  },
  "scripts": {
    "set-env": "ts-node set-env.ts",
    "start": "node backend/dist/index.js",
    "test": "cd backend && npm run test",
    "batch": "cd backend && npm run batch",
    "backend:watch": "cd backend && npm run dev:watch",
    "build": "cd backend && tsc && cd .. && ng build --configuration production",
    "sdk": "cd backend && npm run sdk",
    "sdk:watch": "cd backend && npm run sdk:watch ",
    "angular:watch": "ng build --watch",
    "angular:serve": "ng serve --host=0.0.0.0 --port 4200 --proxy-config proxy.config.json",
    "dev:watch": "concurrently --names \"Angular,Backend,SDK\" -c \"bgGreen.bold,bgBlue.bold,bgMagenta.bold\" \"npm run angular:watch\" \"npm run backend:watch\" \"npm run sdk:watch\"",
    "dev:serve": "concurrently --names \"Angular,Backend,SDK\" -c \"bgGreen.bold,bgBlue.bold,bgMagenta.bold\" \"npm run angular:serve\" \"npm run backend:watch\" \"npm run sdk:watch\"",
    "postinstall": "cd backend && npm i",
    "release": "generate-release"
  },
  "config": {
    "generateRelease": {
      "files_to_version": [
        "azure-pipelines.yml",
        "backend/package.json",
        "backend/package-lock.json",
        "package-lock.json"
      ]
    }
  },
  "dependencies": {
    "@angular-devkit/build-angular": "^21.2.24",
    "@angular/animations": "^21.2.2",
    "@angular/cli": "^21.2.24",
    "@angular/common": "^21.1.3",
    "@angular/compiler": "^21.1.3",
    "@angular/compiler-cli": "^21.1.3",
    "@angular/core": "^21.1.3",
    "@angular/forms": "^21.2.24",
    "@angular/localize": "^21.2.24",
    "@angular/platform-browser": "^21.1.3",
    "@angular/platform-browser-dynamic": "^21.2.24",
    "@angular/router": "^21.2.24",
    "@microsoft/applicationinsights-web": "^3.3.11",
    "@ng-bootstrap/ng-bootstrap": "^20.0.0",
    "@openapitools/openapi-generator-cli": "^2.18.4",
    "@popperjs/core": "2.11.8",
    "angular-file": "4.0.2",
    "bootstrap": "5.3.8",
    "colors": "^1.4.0",
    "jsbarcode": "^3.12.3",
    "moment": "^2.30.1",
    "ng-recaptcha": "^13.2.1",
    "ngx-mask": "^21.0.1",
    "ngx-quill": "^29.2.0",
    "ngx-toastr": "^20.0.5",
    "parchment": "^3.0.0",
    "quill": "^2.0.2",
    "rxjs": "^7.8.0",
    "sanitize-html": "^2.17.1",
    "stacktrace-gps": "^3.1.2",
    "stacktrace-js": "^2.0.2",
    "tslib": "^2.7.0",
    "typescript": "^5.9.3",
    "vite": "^6.4.1",
    "webpack-dev-server": "^6.0.0",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^20.7.0",
    "@angular-eslint/eslint-plugin": "^20.0.0",
    "@angular-eslint/eslint-plugin-template": "^20.0.0",
    "@angular-eslint/schematics": "^20.7.0",
    "@angular-eslint/template-parser": "^20.0.0",
    "@types/lodash": "^4.17.24",
    "@types/node": "^18.19.130",
    "@types/sanitize-html": "^2.16.0",
    "@typescript-eslint/eslint-plugin": "^7.18.0",
    "@typescript-eslint/parser": "^7.18.0",
    "concurrently": "^8.2.2",
    "dotenv": "^16.6.1",
    "eslint": "^8.57.1",
    "eslint-config-prettier": "^9.1.2",
    "eslint-plugin-imengine": "file:eslint",
    "eslint-plugin-prettier": "^5.5.5",
    "generate-release": "^1.1.1",
    "nodemon": "^3.1.14",
    "prettier": "^3.8.1",
    "rimraf": "^5.0.10",
    "tslint": "~6.1.0"
  },
  "overrides": {
    "@angular/cli": {
      "@hono/node-server": "^2.0.11"
    },
    "shell-quote": "^1.12.0",
    "@modelcontextprotocol/sdk": "^1.32.0",
    "uuid": "^11.1.1",
    "brace-expansion": "^5.0.12",
    "@angular/router": "^21.2.24",
    "ng-recaptcha": {
      "@angular/core": "^21.0.0"
    },
    "piscina": "^5.3.2",
    "undici": "^7.24.3",
    "file-type": "^21.3.2",
    "@openapitools/openapi-generator-cli": {
      "@nestjs/core": {
        "path-to-regexp": "^8.4.1"
      }
    },
    "basic-ftp": "^6.2.1"
  }
}
